import { Point, Range } from 'slate';
import LinkifyIt from 'linkify-it';
import { isViewerURL } from 'libs/rendering/utils';

export class NodeLinkify extends LinkifyIt {
  onCompile() {
    this.re.tpl_link_no_ip_fuzzy = this.re.tpl_link_no_ip_fuzzy.replace(
      '))((',
      '))www\\.((',
    );
  }
}

export const buildMatchData = match => {
  const { schema, text, url } = match;
  return { schema, text, url };
};

const linkifyText = (node, editor, matches) => {
  matches.forEach(match => {
    const anchor = Point.create({ key: node.key, offset: match.index });
    const focus = Point.create({ key: node.key, offset: match.lastIndex });
    const range = new Range({ anchor, focus });
    const data = buildMatchData(match);
    editor.wrapInlineAtRange(range, { type: 'linkified-link', data });
  });
};

const breakLinkified = (node, editor) => editor.unwrapInlineByKey(node.key);

export function Linkify() {
  const linkify = new NodeLinkify();
  return {
    onCommand(command, change, next) {
      const { type, args } = command;

      if (type === 'insertFragment') {
        const url = args[0].text;
        if (url && isViewerURL(url)) {
          change.command('insertText', encodeURI(decodeURI(url)));
        }
      }

      next();
    },
    normalizeNode: (node, editor, next) => {
      const { text } = node;
      const parent = editor.value.document.getParent(node.key);

      if (node.object === 'text' && !!parent && parent.type === 'paragraph') {
        const sibling = editor.value.document.getPreviousSibling(node.key);
        if (!!sibling && sibling.type === 'linkified-link') {
          const textUntilSpace = text.split(' ')[0];
          if (textUntilSpace.length) {
            editor.removeTextByKey(node.key, 0, textUntilSpace.length);
            editor.insertTextByKey(
              sibling.nodes.first().key,
              sibling.text.length,
              textUntilSpace,
            );
          }
        }
        if (linkify.pretest(text) && linkify.test(text)) {
          const matches = linkify.match(node.text);
          linkifyText(node, editor, matches);
        }
      } else if (node.type === 'linkified-link') {
        if (!(linkify.pretest(text) && linkify.test(text))) {
          breakLinkified(node, editor);
        } else {
          const match = linkify.match(node.text)[0];
          const url = node.data.get('url');
          if (url !== match.url) {
            const data = buildMatchData(match);
            editor.setNodeByKey(node.key, { data });
          }
        }
      }

      return next();
    },
  };
}
